import { graphql, readInlineData } from "react-relay";

import { section as sectionData } from "~/data";
import type { helpersStyleArticle$key } from "~/queries/__generated__/helpersStyleArticle.graphql";

export const checkIsStyleArticle = (reference: helpersStyleArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersStyleArticle on Article @inline {
        sections {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );

  const [firstSectionEntityId, secondSectionEntityId] =
    article?.sections?.flatMap(section => section?.value?.map(value => value?.entityId)) ?? [];

  return (
    firstSectionEntityId === sectionData.magazine.entityId &&
    secondSectionEntityId === sectionData.style.entityId
  );
};
